import React, { Component } from "react";
import { connect } from 'react-redux';
import Map_TraCuuTNN from "./index"
class TraCuuTNN extends Component {
  constructor(props) {
    super(props);
    const { functions } = props;
    this.state = {
    }
  }

  render() {
      const { user } = this.props
    return (
      <div>
        <Map_TraCuuTNN user={user}/>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.oidc.user,
  functions: state.functions
});

export default connect(mapStateToProps)(TraCuuTNN);
